import { ListSubheader, MenuItem, Select, SelectChangeEvent, SxProps } from '@mui/material';
import { FC } from 'react';

import { PROVINCES, STATES } from './constants';

type Props = {
	defaultValue?: string;
	sx?: SxProps;
	onChange: (event: SelectChangeEvent) => void;
};

export const StateOrProvinceSelect: FC<Props> = ({ defaultValue, sx, onChange }) => (
	<Select fullWidth sx={sx} label='Timezone' defaultValue={defaultValue} onChange={onChange}>
		<ListSubheader>State</ListSubheader>
		{STATES.map((state) => (
			<MenuItem value={state}>{state}</MenuItem>
		))}

		<ListSubheader>Province</ListSubheader>
		{PROVINCES.map((province) => (
			<MenuItem value={province}>{province}</MenuItem>
		))}
	</Select>
);
